import * as style from "./ApplicationList.module.scss";
import Typography from "../../Components/Common/CprimeText";
import React, { useEffect, useState } from "react";
import {
  TextArea,
  TextInput,
  Dropdown,
  DropdownOption,
  Divider,
} from "cprime-foundational-components";
import { saveApiData } from "../../store/slices/apiDetailsSlice";
import { AppDispatch, RootState } from "../../store/store";
import { useSelector, useDispatch } from "react-redux";

interface CreateApiPanelContentProps {
  isEdit: boolean;
  appId: number;
}

const CreateApiPanelContent: React.FC<CreateApiPanelContentProps> = ({
  isEdit,
  appId,
}) => {
  const scssClass = style as any;
  const [api_name, setapi_name] = useState<string>("");
  const [apiEndpoint, setApiEndpoint] = useState<string>("");
  const [apiDescription, setApiDescription] = useState<string>("");
  const [methodType, setMethodType] = useState<DropdownOption[]>([]);
  const dispatch = useDispatch<AppDispatch>();

  const editApiData = useSelector(
    (state: RootState) => state?.apiDetails?.editData,
  );

  const methodTypeOptions: DropdownOption[] = [
    { id: 1, label: "POST", value: "POST" },
    { id: 2, label: "GET", value: "GET" },
    { id: 3, label: "PUT", value: "PUT" },
    { id: 4, label: "DELETE", value: "DELETE" },
    { id: 5, label: "PATCH", value: "PATCH" },
    { id: 6, label: "ANY", value: "ANY" },
  ];

  useEffect(() => {
    if (isEdit) {
      setapi_name(editApiData?.api_name || "");
      setApiEndpoint(editApiData?.endpoint_path || "");
      setApiDescription(editApiData?.description || "");
      const selectedMethodTypes = editApiData?.method_type
        ?.toUpperCase()
        ?.split(", ")
        ?.map((method: string) =>
          methodTypeOptions.find((option) => option.value === method),
        )
        ?.filter(Boolean) as DropdownOption[];
      setMethodType(selectedMethodTypes || []);
    } else {
      setapi_name("");
      setApiEndpoint("");
      setApiDescription("");
      setMethodType([]);
    }
  }, [isEdit, editApiData]);

  const saveApi = () => {
    const saveBody = {
      api_name: api_name,
      endpointPath: apiEndpoint,
      description: apiDescription,
      methodType: methodType?.map((item) => item.value).join(", "),
      appId: appId,
    };
    dispatch(saveApiData(saveBody));
  };

  useEffect(() => {
    saveApi();
  }, [apiDescription, api_name, apiEndpoint, methodType]);

  const handleChange = (field: string, value: string) => {
    if (field === "api_name") {
      setapi_name(value);
    }
    if (field === "apiDescription") {
      setApiDescription(value);
    }
    if (field === "apiEndpoint") {
      setApiEndpoint(value);
    }
  };

  const handleMethodTypeChange = (selected: DropdownOption[]) => {
    setMethodType(selected);
  };

  return (
    <div className={scssClass.panelContent}>
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>API Details</Typography>
      <div className={scssClass.fieldsContent}>
        <div className={scssClass.secondRow} style={{ marginTop: "0px" }}>
          <TextInput
            value={api_name}
            className={scssClass.firstRowChild}
            sx={{
              maxWidth: "100%",
              width: "100%",
              // "& .MuiInputBase-input": { padding: "0.75rem 1rem" },
              // "& .MuiInputBase-root": { height: "39.98px" },
            }}
            onChange={(e) => handleChange("api_name", e?.target?.value)}
            placeholder="Enter Name"
            label="API Name"
          />
        </div>
        <div className={scssClass.secondRow}>
          <TextInput
            value={apiEndpoint}
            className={scssClass.firstRowChild}
            sx={{
              maxWidth: "100%",
              width: "100%",
              // "& .MuiInputBase-input": { padding: "0.75rem 1rem" },
              // "& .MuiInputBase-root": { height: "39.98px" },
            }}
            onChange={(e) => handleChange("apiEndpoint", e?.target?.value)}
            placeholder="Enter Endpoint"
            label="API Endpoint"
          />
        </div>
        {/* Method Type */}
        <div className={scssClass.secondRowMethodType}>
          <Typography className={scssClass.label}>Method Type</Typography>
          <Dropdown
            placeholder="Select"
            optionsTextLimit={200}
            width="100%"
            options={methodTypeOptions}
            selectedOptions={methodType}
            onChange={handleMethodTypeChange}
          />
        </div>
        <div className={scssClass.secondRow}>
          <TextArea
            fullWidth
            placeholder="Enter Description"
            label="API Description"
            value={apiDescription}
            onChange={(e) => handleChange("apiDescription", e?.target?.value)}
            maxLength={500}
          />
        </div>
      </div>
    </div>
  );
};
export default CreateApiPanelContent;
